<ng-container *ngIf="showLoader">
    <div class="courtain-container"></div>
    <div class="spinner-container">
        <mat-spinner></mat-spinner>
    </div>
</ng-container>